function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import { useNavigationList } from "@sprout/list-navigation";
import DragDropContextCustomSensors from "@sprout/client-components/dist/DragDropContextCustomSensors";
import { useClipboard } from "sprout-ui-dom/dist/hooks";
import { getItemUrl, isNotNull } from "sprout-lib";
import { usePostPageEditor } from "../PostPageEditorContext";
import { usePostPage } from "../PostPageContext";
import { PostPageTodoListWithListNavigation } from "../PostPageTodoList";
import useSortTodosAndTodoLists from "../graphql/mutations/useSortTodosAndTodoLists";
import { useTodoSingularAction } from "../PostPageTodo";
const SUPPORTED_ACTIONS = [
    "COPY_TO_CLIPBOARD",
    "EDIT_TODOLIST"
];
const PostPageViewsTodoListTodoList = (props)=>{
    var ref1;
    const { todoList  } = props;
    const { id , rootTopicOrSelf  } = todoList;
    const { disabled  } = usePostPage();
    const { copy  } = useClipboard();
    const { dispatch  } = usePostPageEditor();
    const handleSingularAction = useCallback((command, activeItem)=>{
        if (!activeItem) return false;
        switch(command){
            case "COPY_TO_CLIPBOARD":
                copy(`${process.env.ROOT_URL}${getItemUrl(activeItem)}`);
                return true;
            case "EDIT_TODOLIST":
                if (disabled) return false;
                dispatch({
                    type: "SET_EDITOR",
                    payload: {
                        editor: "EDIT_TODOLIST",
                        editorPosition: id
                    }
                });
                return true;
            default:
                return false;
        }
    }, [
        copy,
        disabled,
        dispatch,
        id
    ]);
    const { Provider , navProps  } = useNavigationList(`PostPageViewsTodoListMain|${todoList}`, useMemo(()=>({
            actions: SUPPORTED_ACTIONS,
            performSingularAction: handleSingularAction
        }), [
        handleSingularAction
    ]));
    const onDragEnd = useSortTodosAndTodoLists();
    const workspaceMembers = useMemo(()=>{
        var ref;
        return ((rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : (ref = rootTopicOrSelf.members) === null || ref === void 0 ? void 0 : ref.nodes) || []).map((topicMember)=>topicMember.user).filter(isNotNull);
    }, [
        rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : (ref1 = rootTopicOrSelf.members) === null || ref1 === void 0 ? void 0 : ref1.nodes
    ]);
    const labels = useMemo(()=>{
        return (rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : rootTopicOrSelf.labels.nodes) || [];
    }, [
        rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : rootTopicOrSelf.labels.nodes
    ]);
    const { todoSingularAction , todoSupportedActions , elements  } = useTodoSingularAction({
        todos: useMemo(()=>todoList.todos.nodes, [
            todoList.todos.nodes
        ]),
        workspaceMembers,
        labels,
        rootTopicId: rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : rootTopicOrSelf.id
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            elements,
            /*#__PURE__*/ _jsx(DragDropContextCustomSensors, {
                onDragEnd: onDragEnd,
                children: /*#__PURE__*/ _jsx(Provider, {
                    children: /*#__PURE__*/ _jsx("div", _objectSpread({}, navProps, {
                        children: /*#__PURE__*/ _jsx(PostPageTodoListWithListNavigation, {
                            disabled: disabled,
                            todoList: todoList,
                            pressToEdit: true,
                            todoSingularAction: todoSingularAction,
                            todoSupportedActions: todoSupportedActions
                        })
                    }))
                })
            })
        ]
    });
};
export default PostPageViewsTodoListTodoList;
